<template>
    <div class="authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4" :style="`background-image: url('calm-beach.jpg');`">
        <div class="ui-bg-overlay bg-white opacity-25"></div>

        <div class="authentication-inner py-5">

            <b-card no-body>
                <div class="p-4 p-sm-5">
                    <!-- Logo -->
                        <!-- <div class="d-flex justify-content-center align-items-center pb-2 mb-4">
                            <div class="ui-w-100">
                            <div class="w-100 position-relative" style="padding-bottom: 14%">
                                <img :src="`${image_path}/storage/assets/images/office/${($store.state.office.logo === null?'default.jpg':$store.state.office.logo)}`" class="d-block ui-w-100" alt="">
                            </div>
                            </div>
                        </div> -->
                    <!-- / Logo -->

                    <h3 class="text-center text-muted font-weight-normal mb-2">Accedé a tu cuenta</h3>

                    <p class="text-center mb-4">¿No tenés cuenta? <router-link :to="{name: 'auth-register'}" >Registrate</router-link></p>
                    <!-- Form -->
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <b-form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off" class="my-1">
                            <b-form-group>
                                <ValidationProvider rules="required" name="Número de documento" v-slot="props">
                                    <b-input v-model="form.body.username" placeholder="Número de documento" />
                                    <div style="display: block" class="invalid-feedback" >{{ props.errors[0] }}</div>
                                </ValidationProvider>
                            </b-form-group>
                            <b-form-group>
                                <ValidationProvider rules="required" name="Contraseña" v-slot="props">
                                    <b-input type="password" v-model="form.body.password" placeholder="Contraseña"/>
                                    <div style="display: block" class="invalid-feedback" >{{ props.errors[0] }}</div>
                                </ValidationProvider>
                            </b-form-group>
                            <p v-if="errors" class="text-danger">{{errors}}</p>
                            <b-form-group class="text-center">
                                ¿Olvidaste tu contraseña? <router-link :to="{name: 'auth-reset-password-request'}" class="">Clic aquí</router-link>
                            </b-form-group>
                            <b-form-group class="text-center">
                                <ladda-btn type="submit" :loading="is_submiting" data-style="zoom-out" class="btn btn-primary btn-block" >Ingresar</ladda-btn>
                            </b-form-group>
                        </b-form>
                    </ValidationObserver>
                    <!-- / Form -->
                </div>
            </b-card>
        </div>
    </div>
</template>

<!-- Page -->
<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>

<script>
export default {
    data () {
        return {
            is_submiting: false,
            errors: '',
            form: {
                body: {
                    username: '',
                    password: '',
                    document_type: ''
                },
                remember: false,
                fetchUser: true,
                staySignedIn: false
            }
        }
    },
    methods: {
        onSubmit () {
            this.is_submiting = true
            const self = this
            this.$store
                .dispatch('auth/login', {
                    body: this.form.body, // VueResource
                    data: this.form.body, // Axios
                    remember: this.form.remember,
                    fetchUser: this.form.fetchUser,
                    staySignedIn: this.form.staySignedIn
                })
                .then(null, (res) => {
                    self.errors = res.response.data.message
                }).finally(() => {
                    this.is_submiting = false
                })
        }
    }
}
</script>
